<script>
    import { fade } from 'svelte/transition';
    import { backOut } from 'svelte/easing';
    import { navigate } from "svelte-routing";
    import { user } from "../../../firebase/auth";
    import { getAuth, signOut } from "firebase/auth";
    import {
        Menu,
        MenuButton,
        MenuItems,
        MenuItem
    } from "@rgossiaux/svelte-headlessui";
    import Fa from "svelte-fa";
    import { faArrowUpRightFromSquare, faEllipsisVertical, faRightFromBracket, faUser } from "@fortawesome/free-solid-svg-icons";

    function signout () {
        const auth = getAuth();
        signOut(auth).then(() => {
        // Sign-out successful.
        }).catch((error) => {
            alert("Fehler bei der Abmeldung aufgetreten. Bitte versuche es gleich erneut.")
        });
    }

    function customanim(node, {
            duration = 400
        }) {
        const o = +getComputedStyle(node).opacity;

		return {
			duration,
			css: t => {
				const eased = backOut(t);

				return `
					transform: scale(${0.8+(eased/5)}) translateY(${20*(1-eased)}%);
                    opacity: ${t * o};`
			}
		};
	}
</script>



<Menu let:open class="account-menu">
    <MenuButton class="account-menu-button menu-item">
        <div class="account-menu-button-content">
            <span class="profile-img">
                {$user.displayName.slice(0,1)}
            </span>
            <span class="account-name">
                <!-- XXX -->
                {$user.displayName??"Account"}
            </span>
            <span>
                <Fa
                    icon={faEllipsisVertical}
                />
            </span>
        </div>
    </MenuButton>
    {#if open}
        <div class="menu-items-container" transition:customanim="{{duration: 150}}">            
            <MenuItems static class="account-menu-items">
                <div class="item-group">
                    <MenuItem let:active on:click={() => {navigate("/account")}}>
                        <span class="account-menu-item" class:active>
                            <Fa
                            icon={faUser}
                            />
                            Account
                        </span>
                    </MenuItem>
                    <MenuItem let:active on:click={signout}>
                        <span class="account-menu-item" class:active>
                            <Fa
                                icon={faRightFromBracket}
                            />
                            Abmelden
                        </span>
                    </MenuItem>
                </div>
                <div class="item-group">
                    <MenuItem let:active href="/datenschutz" target="_blank">
                        <span class="account-menu-item" class:active>
                            <Fa
                                icon={faArrowUpRightFromSquare}
                            />
                            Datenschutz
                        </span>
                    </MenuItem>
                    <MenuItem let:active href="/impressum" target="_blank">
                        <span class="account-menu-item" class:active>
                            <Fa
                                icon={faArrowUpRightFromSquare}
                            />
                            Impressum
                        </span>
                    </MenuItem>
                </div>
            </MenuItems>
        </div>
    {/if}
</Menu>


<style>
    .account-menu-button-content {
        width: 100%;
        display: flex;
        gap: 1rem;
        line-height: 2rem;
    }

    .account-name {
        text-align: left;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .account-menu-item {
        color: #333;
        cursor: pointer;
        display: flex;
        justify-content: left;
        align-items: center;
        gap: 1rem;
        padding: 0.5rem 1rem;
        text-decoration: none;
    }

    .account-menu-item.active {
        background-color: #ebe6e2;
        background-color: #F5F2EF;
        background-color: #e2ddd8;
        background-color: #E0D8D2;
    }
    
    .profile-img {
        width: 2rem;
        height: 2rem;
        border-radius: 100%;
        display: block;
        overflow: hidden;
        margin: 0;
        padding: 0;
        background-color: #0047FF;
        background: linear-gradient(#F58100, #E22213);
        color: white;
        font-weight: bold;
        font-size: 0.8rem;
        border: 0;
        text-transform: capitalize;
        flex-grow: 0;
        flex-shrink: 0;
    }

    .item-group {
        padding: 0.5rem 0;
    }

    .item-group:not(:last-of-type) {
        border-bottom: 1px solid #ebe6e2;
        border-bottom: 1px solid #F5F2EF;
    }
    
    /* button:active {
        background-color: #0047FF;
    }

    #account-settings-widget {
        position: absolute;
        background-color: white;
        border: 1px solid #eee;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        bottom: 2.5rem;
        left: 0;
        border-radius: 0.5rem;
        padding: 0.5rem;
        display: flex;
        flex-direction: column;
    }

    .menu-list {
        margin: -0.5rem -0.5rem 0;
    } */
</style>